import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import Form from 'antd/es/form';
import React from 'react';
import { StakeholderType } from '@sonar-software/sonar-core';
import { Radio, Space } from 'antd';
export const StakeholderTypeOption = ({ disabled, id, label, name = 'type' }) => React.createElement(Form.Item, { id: id, label: label, name: name },
    React.createElement(Radio.Group, { disabled: disabled },
        React.createElement(Space, { direction: 'vertical' },
            React.createElement(Radio, { value: StakeholderType.Individual }, COPY_SPECIFIC.INDIVIDUAL),
            React.createElement(Radio, { value: StakeholderType.Team }, COPY_SPECIFIC.TEAM))));
